const Companies = { service: 'auth', model: 'Companies' };

export default {
  state: {
    companies: [],
  },
  getters: {
    companies: state => state.companies,
  },
  actions: {
    getCompanies({ dispatch, commit }) {
      const fields = ['id', 'tradingName'];
      return dispatch('Acacia/Utils/Resources/GET', {
        ...Companies,
        params: { filter: { fields } },
      })
        .then(response => commit('SET_COMPANIES', response));
    },
  },
  mutations: {
    SET_COMPANIES(state, payload) {
      state.companies = payload;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/companies.js